export function normalizePostalCode(value: string): string {
  const compact = value.replace(/\s/g, "").toUpperCase();
  return compact.length === 6
    ? `${compact.slice(0, 3)} ${compact.slice(3)}`
    : compact;
}

export function validatePostalCode(
  value?: string,
  required = false,
): string | undefined {
  if (!value?.trim()) return required ? "Postal code is required" : undefined;
  return /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z] \d[ABCEGHJ-NPRSTV-Z]\d$/.test(
    normalizePostalCode(value),
  )
    ? undefined
    : "Enter a Canadian postal code, for example X0E 0T0";
}
